export const DEFAULT_DATE_FORMAT = 'dd MMMM yyyy';
export const TIME_DATE_FORMAT_WITH_COMMA = 'dd MMMM yyyy, kk:mm';
export const TIME_DATE_MONTH_WITH_COMMA = 'dd MMMM, kk:mm';
export const DAY_ONLY = 'dd';
export const MONTH_SHORT = 'LLL';
export const MONTH_DAY_SHORT = 'LLL dd';
export const CALENDAR_DATE_KEY_FORMAT = 'yyyy-MM-dd';
export const COMPLETED_TARGET_FORMAT = 'dd.MM.yyyy';
